const sidebar = {
  sidebar: {
    editProfile: 'Settings',
    logout: 'Logout',
    yourTime: 'Your time',
    collapseSidebar: 'Collapse Sidebar',
    general: 'General',
    management: 'Management',
    bonusProgram: 'Bonus Program',
  },
}

export default sidebar
